import type { DecisionSource } from '@/lib/admin/client';

// Shared facet-count label helpers + the decision-source display map. The `policy` -> "AI"
// mapping lives here once so the toolbar and the roll-up lanes never diverge on how a
// decision maker is named.

export function facetCount(
  dimension: Record<string, number> | undefined,
  key: string
): number | undefined {
  return dimension?.[key];
}

export function withCount(label: string, value: number | undefined): string {
  return typeof value === 'number' ? `${label} (${value})` : label;
}

export const DECISION_SOURCE_OPTIONS: Array<{
  label: string;
  value: DecisionSource;
}> = [
  { label: 'Human', value: 'human' },
  { label: 'AI', value: 'policy' },
  { label: 'System', value: 'system' },
];
